import * as React from "react";
import { forwardRef } from "react";
const SvgChevronCleanSize = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 9.2 15.7", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("style", null, "\n      .cls-1 {\n        fill-rule: evenodd;\n      }\n    ")), /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("g", { id: "Layer_1" }, /* @__PURE__ */ React.createElement("path", { className: "cls-1", d: "M1.4,15.7l-.7-.7,7.1-7.1L.6.7,1.4,0l7.9,7.9L1.4,15.7Z" }))));
const ForwardRef = forwardRef(SvgChevronCleanSize);
export { ForwardRef as ReactComponent };
